import { Link } from 'react-router-dom';

export function NotFoundView() {
  return (
    <div className="text-center py-20 px-6">
      <h1 className="text-on-surface text-[48px] font-bold m-0 mb-4">
        404
      </h1>
      <p className="text-on-surface-variant text-xl mb-6">
        Page not found.
      </p>
      <Link
        to="/"
        className="py-3 px-7 bg-primary text-on-primary rounded-pill font-semibold text-[15px] no-underline"
      >
        Go Home
      </Link>
    </div>
  );
}
